module.exports = __webpack_public_path__ + "static/media/isdb_1.45b72a56.png";